import React from 'react';
import logo from '../media/Logos/logo-dabi-gris.png';
import "../scss/Components/_errorscreen.scss"
import { Helmet } from 'react-helmet';
import { useTranslationHook } from '../hooks/UseTranslationHook';


function NonAuthScreen() {
  const {
    titleNonAuthString
  } = useTranslationHook();
  
  return (
    <div className="error-screen">
      <Helmet>
        <title>{titleNonAuthString}</title>
      </Helmet>
      <img src={logo} alt="Logo de DABI" className="logo" />
      <h1 className='h1-error-screen'>No autorizado.</h1>
      <p className='p-error-screen'>Código de error: 401</p>
      <p className='p-error-screen'>Proporciona credenciales autorizadas o ponte en contacto con un administrador en caso de que consideres que es un error.</p>
      <a className='a-error-screen' href="/">Volver a inicio de sesión</a>
    </div>
  );
}

export default NonAuthScreen;